<template>
  <div>
    <div class="app-title">
      <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
    </div>
    <section class="app-content" v-menu-permission="'list'">
      <div id="accordionFilter" class="content">
        <div class="card">
          <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
               data-parent="#accordionFilter">
            <div class="card-body">
              <form>
                <em-filter :entity="modelName" ref="emListFilter"
                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div id="emOpcUaNodeSubscriptionEounsResultTable" class="content">
        <div class="card my-1">
          <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
               data-parent="#accordionResult">
            <div class="card-body">
              <em-table :entity="modelName" withCustomRowActions
                        ref="emTable" import-enabled :inlineActionsDisabled="prop_inline!=='1'"
                        @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                        @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                <template #left-header>
                  <em-button type="import"
                             custom-label="批量订阅"
                             v-bind:class="'btn btn-outline-primary btn-sm'"
                             :busy="onBatchSubscription"
                             v-b-modal.modal-batch-subscription
                  >
                  </em-button>
                  <em-button type="check" custom-icon="fa fa-refresh"
                             custom-label="刷新订阅"
                             v-bind:class="'btn btn-outline-primary btn-sm'"
                             :busy="onReSubscription"
                             @click="reSubscription"
                  ></em-button>
                </template>
              </em-table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    <b-modal id="modal-batch-subscription" title="批量订阅" hide-footer>
      <b-form @submit="handleBatchSubscript" @reset="handleBatchSubscriptReset">
        <b-row class="my-1">
        <b-col sm="3">
          <label>增量or全量订阅</label>
        </b-col>
        <b-col sm="9">
          <el-switch
              style="display: block"
              v-model="imfOpcBatchSubscriptDto.incremental"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="增量">
          </el-switch>
        </b-col>
      </b-row><b-row class="my-1">
        <b-col sm="3">
          <label>队列是否覆盖</label>
        </b-col>
        <b-col sm="9">
          <el-switch
              style="display: block"
              v-model="imfOpcBatchSubscriptDto.discardOldest"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="是">
          </el-switch>
        </b-col>
      </b-row>
        <b-row class="my-1">
          <b-col sm="3">
            <label>服务名（为空则订阅所有服务名下节点）:</label>
          </b-col>
          <b-col sm="9">
            <b-form-input id="serverName" type="text" v-model="imfOpcBatchSubscriptDto.serverName"></b-form-input>
          </b-col>
        </b-row><b-row class="my-1">
          <b-col sm="3">
            <label>订阅周期（秒）:</label>
          </b-col>
          <b-col sm="9">
            <b-form-input id="interval" type="number" v-model="imfOpcBatchSubscriptDto.interval"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="3">
            <label>队列长度（秒）:</label>
          </b-col>
          <b-col sm="9">
            <b-form-input id="queueSize" type="number" v-model="imfOpcBatchSubscriptDto.queueSize"></b-form-input>
          </b-col>
        </b-row>
        <b-row align-h="end" style="margin-top: 30px">
          <b-button type="submit" variant="primary">确定</b-button>
          <b-button type="reset" variant="danger">取消</b-button>
        </b-row>
      </b-form>
    </b-modal>
  </div>
</template>
<script>
// Author YuJiaBei
// Date 2021-07-18 10:45:03

import emCommonListMixin from "@/mixin/em/common/list";
import emApiMixin from "@/mixin/em/common/api";
import commonViewsUtil from "@/utils/commonViewsUtil";

export default {
  name: "emOpcUaNodeSubscriptionEounsListView",
  mixins: [emCommonListMixin, emApiMixin],
  props: {
    //是否启用行编辑
    prop_inline: {
      type: String,
      default: "0"
    }
  },
  data() {
    return {
      onReSubscription: false,
      onBatchSubscription: false,
      imfOpcBatchSubscriptDto: {
        serverName: '',
        incremental: true,
        discardOldest: true,
        interval: 5,
        queueSize: 1
      }
    }
  },
  methods: {
    reSubscription() {
      this.onReSubscription = true
      this.$_emApiMixin_post(this.$_emApiMixin_moduleBaseApi("emOpcComputedEoc") + "/emOpcUaResource/reSubscription", {})
          .then((res) => {
            commonViewsUtil.showSuccess(this, "重新订阅成功")
            this.onReSubscription = false
          })
    },
    handleBatchSubscript(event) {
      event.preventDefault()
      this.onBatchSubscription = true
      this.$_emApiMixin_post(this.$_emApiMixin_moduleBaseApi("emOpcComputedEoc") + "/emOpcUaNodeSubscriptionEouns/subscribeBatch", this.imfOpcBatchSubscriptDto)
          .then(response => {
            commonViewsUtil.showSuccess(this, "批量订阅成功")
            this.$refs.emListFilter.doQuery()
          }).finally(() => this.onBatchSubscription = false);
      this.$nextTick(() => {
        this.$bvModal.hide('modal-batch-subscription')
      })
    },
    handleBatchSubscriptReset() {
      this.$nextTick(() => {
        this.$bvModal.hide('modal-batch-subscription')
      })
    },
  },
  computed: {
    modelName() {
      return this.$_emRouterHelperMixin_entityName
    }
  }
};
</script>